export default "__VITE_ASSET__CgMZD4qB__"